/**
 * @desc 分页条件查询sku新品列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.PlmSkuNewOrderListResponseDto>
>;
export function request(
  body: defs.basics.PlmSkuNewOrderRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/order/page`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
